import sanitizeHtmlPackage, { IOptions } from 'sanitize-html';

export const sanitizeConfigs = {
  defaultWithImageAndHeadings: {
    allowedTags: sanitizeHtmlPackage.defaults.allowedTags.concat([
      'bold',
      'img',
      'h1',
      'h2',
      'svg',
      'path',
    ]),
    allowedAttributes: {
      // enable svg attributes for SvgIcon component
      '*': ['id', 'viewBox'],
      svg: ['*'],
      path: ['*'],
      a: ['href', 'target', 'rel', 'aria-label'], // allow basic links
    },
    parser: { lowerCaseAttributeNames: false },
  },
};

// wrapper function to pass default configuration
// note that if passing an alternative configuration, complete configuration must be passed
export const sanitizeHtml = (
  html: string,
  config: IOptions = sanitizeConfigs.defaultWithImageAndHeadings
): string => sanitizeHtmlPackage(html, config);

export const stripParagraphsWithNbsp = (htmlAsString: string): string =>
  htmlAsString.split('<p>&nbsp;</p>').join('');

export const chain = (
  value: unknown,
  functions: Array<(param: any) => any>
): unknown => functions.reduce((r, f) => f(r), value);
